import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {MailTempType} from "@pages/email/common/Constant";
import UpdateFullMailTemplateModal from "@pages/email/template/edit/UpdateFullMailTemplateModal";
import FullMailBasicInfo from "@pages/email/common/view/FullMailBasicInfo";
import FullMailSubjectTemp from "@pages/email/common/view/FullMailSubjectTemp";
import FullMailBodyTemplateTabs from "@pages/email/common/view/FullMailBodyTemplateTabs";
import FullMailChooseYourSignatures from "@pages/email/common/view/FullMailChooseYourSignatures";
import FullMailChooseYourEmails from "@pages/email/common/view/FullMailChooseYourEmails";

const DraftPreviewModal = (props) => {
    const [runJobData, setRunJobData] = useState([]);
    const [canIds, setCanIds] = useState([]);
    const [mailTemId, setMailTemId] = useState("");

    const {candidateIds, mailTemplateId, isShow, onClose} = props


    useEffect(() => {
        if (candidateIds) {
            setCanIds([...candidateIds])
        }
    }, [candidateIds]);

    return (
        <>
            <Modal show={isShow}
                   fullscreen
                   size={'xl'}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {'Run Job'}
                    </Modal.Title>
                    <div className={"row"}>
                        <Button variant='secondary' onClick={() => onClose()}>
                            Close
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <FullMailBasicInfo template={runJobData.invite_mail_template} onChange={(basicInfo) => {}}/>
                    {/*<FullMailSubjectTemp content={mailSubject} onChange={(content) => onChangeSubject(content)}/>*/}
                    {/*<FullMailBodyTemplateTabs content={mailContent} onChange={(content) => onChangeMailContent(content)}/>*/}
                    {/*<FullMailChooseYourSignatures content={mailTemplate.signature_body} onChange={(content) => onChangeSignatureBody(content)}/>*/}
                    {/*<FullMailChooseYourEmails sendingEmails={mailTemplate.sending_emails} onChange={(content) => onChangeSendingEmails(content)}/>*/}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DraftPreviewModal;
